if (!customElements.get("collection-features")) {
  class ComponentCollectionFeatures extends HTMLElement {
    constructor() {
      super();
      this.btnEls = this.querySelectorAll(".btn-feature");
      this.featureEls =
        this.closest(".content").querySelectorAll(".image-feature, .text-feature");
      this.initButtons();
      this.showFeature("image-1");
    }

    showFeature(featureId) {
      console.log(featureId);
      this.querySelector(`.btn-${featureId}`).classList.add("active");
      this.closest(".content")
        .querySelector(`.image-feature.${featureId}`)
        .classList.add("active");
      this.closest(".content")
        .querySelector(`.text-feature.${featureId}`)
        .classList.add("active");
    }

    initButtons() {
      this.btnEls.forEach((btnEl) => {
        btnEl.addEventListener("click", (event) => {
          this.featureEls.forEach((featureEl) =>
            featureEl.classList.remove("active")
          );
          this.btnEls.forEach((btnEl) => btnEl.classList.remove("active"));
          this.showFeature(event.currentTarget.dataset.target);
        });
      });
    }
  }
  customElements.define("collection-features", ComponentCollectionFeatures);
}
